import React from 'react';
import classNames from 'classnames';
import './table-heading.scss';

export const TableHeading = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <h3 className={classNames('table-heading', className)}>{children}</h3>;
};
